import { axios, Response } from '../index'
import { Operational } from './get-clinic-operators'

interface Body {
  cpf: string
  email: string
  accessProfileIds: string[]
  name: string
  lastName: string
}

const createOperators = (body: Body): Response<Operational> => {
  return axios.post('/v1/operators', body)
}

export default createOperators
